import React from "react";
import Blog from "../../components/blog/blog";

export const Food = () => {
  return <Blog />;
};
